import type { SxProps, Theme } from '@mui/material/styles';
import { InspectionStatus } from 'shared/domain/inspection/inspectionModel';
import { Color } from 'shared/utils/colors';
import { InspectionStatusSize } from './types';

export const statusColors: Record<InspectionStatus, string> = {
  [InspectionStatus.inProgress]: Color.statusDraftAmber,
  [InspectionStatus.completed]: Color.statusSuccessGreen,
};

export const sizeStyles: Record<InspectionStatusSize, SxProps<Theme>> = {
  [InspectionStatusSize.small]: {
    fontSize: '0.625rem',
    lineHeight: '0.7rem',
  },
  [InspectionStatusSize.default]: {
    fontSize: '0.75rem',
    lineHeight: '0.75rem',
  },
  [InspectionStatusSize.table]: {
    fontSize: '0.75rem',
    lineHeight: '0.75rem',
  },
};

export const baseContainerSx: SxProps<Theme> = {
  fontFamily: 'Archivo',
  fontWeight: 700,
  textTransform: 'none',
};
